export default __webpack_public_path__ + "static/media/sh_4.21c55867.png";